import { render, staticRenderFns } from "./FeeRemindView.vue?vue&type=template&id=7b7280fe&"
import script from "./FeeRemindView.vue?vue&type=script&lang=ts&"
export * from "./FeeRemindView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports